import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { NumberFormControl } from './number-form-control';

@Component({
  standalone: false,
  selector: 'app-number-form-control',
  templateUrl: './number-form-control.component.html',
  styleUrls: ['./number-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberFormControlComponent),
      multi: true
    }
  ]
})
export class NumberFormControlComponent
  extends AbstractFormControlComponent<NumberFormControl>
  implements ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;
  @Input() fraisInclus?: boolean;
  @Input() aCeJour?: boolean;
  @Input() inline: boolean;

  onChange: any = (value: string) => {};
  onTouched: any = () => {};

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  faCheck: any = faCheck;

  get minLength(): number {
    return this.control.minLength;
  }

  get maxLength(): number {
    return this.control.maxLength;
  }

  get placeholder(): string {
    return this.control.placeholder || '';
  }

  get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }

  public get isInline(): boolean {
    return this.inline || false;
  }

  get disabledGreenBorder(): boolean {
    return this.control.disabledGreenBorder || false;
  }

  get allowNegativeNumbers(): boolean {
    return this.control.allowNegativeNumbers || false;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }

  public get hideErrorMessages(): boolean {
    return this.control.hideErrorMessages || false;
  }
}
